import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { NotificationsActivitiesService } from 'src/app/service/calendar-service/notifications-activities.service';
import { LanguageService } from 'src/app/service/language-service/language.service';

@Component({
  selector: 'app-activity-and-notification-modal',
  templateUrl: './activity-and-notification-modal.component.html',
  styleUrls: ['./activity-and-notification-modal.component.scss'],
})
export class ActivityAndNotificationModalComponent implements OnInit {
  @Input() notifications: any[] = [];
  @Output() closePanel = new EventEmitter<void>();
  @Output() goToFullView = new EventEmitter<void>();
  language:string = "es";
  laguageSub: Subscription;
  isLoading: boolean = false;
  private loadingSub: Subscription;

  constructor(
    public notificationsActivitiesService: NotificationsActivitiesService,
    private languageService: LanguageService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.subLanguageConfig();
    this.loadingSub = this.notificationsActivitiesService.isLoading$.subscribe(loading => {
      this.isLoading = loading;
    });
  }

  onNotificationClick(notification: any) {
    if (!notification?.is_read) {
      this.notificationsActivitiesService.readNotification(notification);
    } else {
      this.notificationsActivitiesService.pathNotification(notification);
    }
  }

  onGoToFullView() {
    this.goToFullView.emit();
  }

  subLanguageConfig() {
    this.laguageSub = this.languageService.getCurrentLang().subscribe(lang => {
      this.translate.currentLang = '';
      this.translate.setDefaultLang(lang);
      this.translate.use(lang);
      this.language = lang;
      // console.log("firma comp ", this.language)
    });
  }

  ngOnDestroy() {
    if (this.laguageSub) {
      this.laguageSub.unsubscribe();
    }
    if (this.loadingSub) {
      this.loadingSub.unsubscribe();
    }
  }
}
